import { PreguntaExportador } from "../PreguntaExportador";
import { FilasExcel, PreguntasTipoEnum } from "@shared/enums";
import { DatosEncuestaExportar } from "../DatosEncuestaExportar";

export class PreguntaVideoExportador extends PreguntaExportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.VIDEO;
    }

    protected generarFilaPregunta(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string> {
        const fila = super.generarFilaPregunta(datosEncuesta);
        fila.set(FilasExcel.ITEMS, datosEncuesta.pregunta.url);
        return fila;
    }
}
